'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInUp = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '100%', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInUp;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-up.js
// module id = 216
// module chunks = 54990529738226 257444579329143